const url = 'roles';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_ROL = 'LOADER_ROL';
const SET_DATA_ROL = 'SET_DATA_ROL';
const SET_PAGE_ROL = 'SET_PAGE_ROL';
const SET_UPDATE_DATA_ROL = 'SET_UPDATE_DATA_ROL';
const SET_BUSCADOR_ROL = 'SET_BUSCADOR_ROL';
const SET_FILTRO_ROL = 'SET_FILTRO_ROL';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_ROL, cargando: true});
    const store = getStore();
    const search = store.roles.buscador;
    const filtro = store.roles.filtro_roles;
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_ROL, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_ROL, data});
            dispatch({type: SET_PAGE_ROL, page});
        }
        dispatch({type: LOADER_ROL, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_ROL, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_ROL, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/users'))
        }
    }).then((data) => {
        dispatch({type: LOADER_ROL, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_ROL, updateData: data});
            dispatch(initializeForm('roles', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.roles.values;
    dispatch({type: LOADER_ROL, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_ROL, cargando: false})
        Swal('Éxito', 'Se ha creado el rol.', 'success')
        .then(() => {
            dispatch(push('/roles'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_ROL, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_ROL, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.roles.values);
    dispatch({type: LOADER_ROL, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_ROL, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/roles'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_ROL, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/roles/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_ROL, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_ROL, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_ROL, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_ROL, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_ROL, filtro_rol: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_ROL]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_ROL]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_ROL]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_ROL]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_ROL]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_ROL]: (state, { filtro_rol }) => {
        return {...state, filtro_rol }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_roles: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
